export {
  getAiGuidanceBadgeConfig,
  getSredCategoryBadgeConfig,
  type ProjectBadgeConfig,
} from './sred-eligibility.utils';
export {
  getSredDocumentationStatus,
  hasAllDocumentation,
  hasSystematicInvestigation,
  hasTechnologicalAdvancement,
  hasTechnologicalUncertainty,
  hasSupportingWork,
  makeSredDetailsDescription,
  mapStringToSortField,
  type SredDocumentationStatus,
} from './sred-project.utils';
export { getSredNavSection, isSredPathAvailable, type SredPath } from './sred-path.utils';
